/**
 * API Configuration
 * Uses environment variable for production, defaults to localhost for development
 */
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default API_URL;

